import {Directive, ElementRef, HostListener, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {SortableTableDirective, SortOrder} from './sortable-table.directive';

export type SortableType = 'string' | 'number';

@Directive({
  selector: '[appSortable]',
  standalone: true
})
export class SortableHeaderDirective implements OnInit, OnDestroy {
  @Input('appSortable') appSortable: string = '';
  @Input('sortType') sortType: SortableType = 'string';

  private iconEl: HTMLElement | null = null;

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    private parent: SortableTableDirective
  ) {
  }

  ngOnInit(): void {
    this.parent.register(this);

    this.renderer.addClass(this.el.nativeElement, 'app-sortable');

    this.iconEl = this.renderer.createElement('i');
    this.renderer.addClass(this.iconEl, 'bi');
    this.renderer.addClass(this.iconEl, 'app-sortable-icon');
    this.renderer.appendChild(this.el.nativeElement, this.iconEl);
  }

  ngOnDestroy(): void {
    this.parent.unregister(this);
  }

  @HostListener('click')
  onClick(): void {
    if (!this.appSortable) {
      return;
    }
    this.parent.sortBy(this.appSortable, this.sortType);
  }

  updateState(order: SortOrder | null): void {
    if (!this.iconEl) {
      return;
    }

    this.renderer.removeClass(this.iconEl, 'bi-caret-up-fill');
    this.renderer.removeClass(this.iconEl, 'bi-caret-down-fill');

    if (order === 'desc') {
      this.renderer.addClass(this.iconEl, 'bi-caret-up-fill');
    } else if (order === 'asc') {
      this.renderer.addClass(this.iconEl, 'bi-caret-down-fill');
    }
  }
}
